import type { EmployeeContactInfo, UpdateEmployeeContactRequest } from '../types';

const PENDING_FLAG_KEY = 'pendingPhoneSelector';

export function markPhoneSelectorPending(): void {
  try {
    sessionStorage.setItem(PENDING_FLAG_KEY, '1');
  } catch {
    /* noop — приватный режим/квота: нудж просто не покажется в этой сессии */
  }
}

export function consumePendingFlag(): boolean {
  try {
    const pending = sessionStorage.getItem(PENDING_FLAG_KEY) === '1';
    if (pending) {
      sessionStorage.removeItem(PENDING_FLAG_KEY);
    }
    return pending;
  } catch {
    return false;
  }
}

export function parsePhoneOptions(ipPhoneList: string | undefined): string[] {
  return (ipPhoneList ?? '')
    .split(',')
    .map((value) => value.trim())
    .filter((value) => value.length > 0);
}

export function buildPhoneOnlyPayload(
  contact: EmployeeContactInfo,
  newPhone: string
): UpdateEmployeeContactRequest {
  return {
    phone: contact.phone ?? '',
    email: contact.email ?? '',
    telegram_chat_id: contact.telegram_chat_id ?? '',
    custom_http: contact.custom_http ?? '',
    custom_xmpp: contact.custom_xmpp ?? '',
    ip_phone: newPhone,
    ip_phone_list: contact.ip_phone_list ?? '',
    comment: contact.comment ?? '',
    account: { is_blocked: contact.account.is_blocked },
    twofa: { enabled: contact.twofa.enabled },
    ip_access: { list: contact.ip_access.list ?? [] },
  };
}
